const ROUTES = {
  "/": {
    "name": "HomePage7c26776762b543d5Afb626575d0a5643",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPagesE674cbda071d4c4b85cfA06f6ec3af19",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage8ac4aff80a26424e9003F896586e9d3a",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/events/public": {
    "name": "PublicEventsPageF999e539E9a848fe92d8537de632b12a",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage77e6c1cfFbd1485aB04420f508269353",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/login": {
    "name": "LoginPageD342b899508447d9896aF6109019de60",
    "type": "HTML",
    "key": "login-page"
  },
  "/members/*": {
    "name": "MemberPagesDd3879f03f21403aAa00045afeb31cb2",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages86785c3f3c7144e1B7f42cbfd3473d77",
    "type": "HTML",
    "key": "message-pages"
  },
  "/reset_password": {
    "name": "PasswordResetPage87067b3dC7864aafB66c44797d6193df",
    "type": "REFERENCE",
    "key": "password-reset-page"
  },
  "/resources": {
    "name": "ResourcesPageC1007033E4ac4a298d6bAcd4a49458dd",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages5f4c8c280da64c1284d0D66e10680d8e",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;